import { Patientallergy, PatientAllergyControllerApi } from "../../services";
import { getConfigObject, useMutationWithLoading } from "../../utils/utils";

/**
 * @author Rajkumar Rathod
 */
export const usePatientAllergiesUpdate = () =>
  useMutationWithLoading(
    async (params: { patientAllergy: Patientallergy; xTENANTID?: string }) =>
      new PatientAllergyControllerApi(getConfigObject()).updatePatientAllergy(
        params.patientAllergy,
        params.xTENANTID
      )
  );
